import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {Analytics} from '../../../services/analytics';
import {TriggersTable, TriggersTableProps} from './TriggersTable/TriggersTable';

type AutomationsTabProps = Pick<
  TriggersTableProps,
  'projectTriggersQuery' | 'baseTriggerDrawerInit' | 'readOnly'
> & {
  entityName: string;
  projectName: string;
};

export const AutomationsTab = ({
  entityName,
  projectName,
  baseTriggerDrawerInit,
  readOnly,
  projectTriggersQuery,
}: AutomationsTabProps) => {
  const location = useLocation();

  // Analytics: fire once on arrival
  useEffect(() => {
    Analytics.track('Automations Tab Viewed', {
      type: 'page_view',
      page: 'automations',
      location: location.pathname,
      entityName,
      projectName,
    });
    // Only track on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TriggersTable
      projectTriggersQuery={projectTriggersQuery}
      baseTriggerDrawerInit={baseTriggerDrawerInit}
      readOnly={readOnly}
    />
  );
};
